import { Injectable } from '@angular/core';
import { ajax, AjaxRequest } from 'rxjs/ajax';

@Injectable({
  providedIn: 'root'
})
export class ShareDataServiceService {

  constructor() { }

  get(request:AjaxRequest,itemName:string) {
    return new Promise<any>((resolve: (a: any) => void,reject: (a: any) => void): void => {
      const currentData = localStorage.getItem(itemName);
      const currentObject = currentData?JSON.parse(currentData):null;
      if(!this.isExpired(currentObject) && (!Array.isArray(currentObject.data) || currentObject.data.length>0))
        resolve(currentObject.data);
      else{
        const req = ajax(request);
        req.subscribe(res => {
            this.set(itemName,res.response);
            resolve(res.response);
        },err=>{
          console.log(err);
          reject(err);
        });
      }
    });
  }

  set(itemName:string,itemData:any){
    const expiredDate:Date = new Date();
    expiredDate.setHours(0,0,0,0)
    expiredDate.setDate(expiredDate.getDate()+1);
    localStorage.setItem(itemName,JSON.stringify({expired:expiredDate.toJSON(),data:itemData}));
  }

  isExpired(storageObject:any):boolean{
    return (!storageObject || !storageObject.expired || new Date().toJSON()>storageObject.expired);
  }
}
